import { useTranslation } from "react-i18next";

/**
 * Idioma activo normalizado ("es" | "en").
 * El contenido editorial vive en src/data/* como objetos { es, en };
 * este hook y `pick` son el puente entre ese contenido y la UI.
 */
export function useLang() {
  const { i18n } = useTranslation();
  return i18n.language && i18n.language.startsWith("en") ? "en" : "es";
}

/** Devuelve el valor del idioma pedido con fallback a español. */
export function pick(value, lang) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return value[lang] ?? value.es ?? value.en ?? "";
}

/** Helper con el idioma ya resuelto: const L = useL(); L(obj) */
export function useL() {
  const lang = useLang();
  return (value) => pick(value, lang);
}
